import React from 'react'

import { HighLightsParsing, ParsingData } from '../../components'
import { GalleryIcon, ServerIcon } from '../../screenshots'

const ParsingHero = () => (
  <>
    <HighLightsParsing />
    <div className="mx-5 lg:mx-0 mt-10 lg:mt-[124px] flex flex-col lg:items-center z-20">
      <span className="block text-[36px] leading-[40px] lg:text-[95px] lg:leading-[100px] text-[#FBFBFC] font-medium -tracking-[2px] lg:-tracking-[3px] lg:text-center">
        Парсим данные <br className="lg:hidden" />и сайты{' '}
        <br className="hidden lg:block" />
        для <br className="lg:hidden" />
        вашего бизнеса
      </span>
      <span className="block text-[36px] leading-[40px] lg:text-[95px] lg:leading-[100px] text-[#52575D] font-medium -tracking-[2px] lg:-tracking-[3px]">
        любой сложности
      </span>
      <div className="mt-6 mb-10 lg:mb-0 lg:mt-10 hidden lg:flex flex-col lg:items-center">
        <div className="flex items-center">
          <span className="block text-[#FBFBFC] font-medium text-[16px] leading-[24px] lg:text-[28px] lg:leading-[40px] mr-3">
            Парсим более
          </span>
          <GalleryIcon />
          <span className="block text-[#FBFBFC] font-medium text-[16px] leading-[24px] lg:text-[28px] lg:leading-[40px] ml-2.5">
            128 000 000 товаров в сутки
          </span>
        </div>
        <div className="flex items-center">
          <span className="block text-[#FBFBFC] font-medium text-[16px] leading-[24px] lg:text-[28px] lg:leading-[40px] mr-3">
            на серверах мощностью более
          </span>
          <ServerIcon />
          <span className="block text-[#FBFBFC] font-medium text-[16px] leading-[24px] lg:text-[28px] lg:leading-[40px] ml-2.5">
            384 ядер
          </span>
        </div>
      </div>
      <div className="block lg:hidden mt-10 space-y-3">
        <span className="block text-[16px] font-medium leading-[24px] text-[#FBFBFC]">
          Парсим более
        </span>
        <div className="p-4 rounded-[12px] border border-[rgb(251,251,252,0.12)] flex items-center space-x-4 w-fit">
          <GalleryIcon />
          <span className="block text-[#FBFBFC] text-[28px] leading-[36px] font-medium">
            128 000 000
          </span>
        </div>
        <span className="block text-[16px] font-medium leading-[24px] text-[#FBFBFC]">
          товаров в сутки на серверах
          <br />
          мощностью более
        </span>
        <div className="p-4 rounded-[12px] border border-[rgb(251,251,252,0.12)] flex items-center space-x-4 w-fit">
          <ServerIcon />
          <span className="block text-[#FBFBFC] text-[28px] leading-[36px] font-medium">
            384 ядер
          </span>
        </div>
      </div>
    </div>
    <div className="flex items-center mt-[100px] lg:mt-[119px] relative">
      <ParsingData />
    </div>
  </>
)

export { ParsingHero }
